import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Scan } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0a0f0d]/80 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2.5 group">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/20">
            <Scan className="w-4 h-4 text-[#0a0f0d]" strokeWidth={2.5} />
          </div>
          <span className="font-display font-semibold text-xl tracking-tight">
            Closet<span className="text-emerald-400">Flip</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-300">
          <Link to="/" className="hover:text-emerald-400 transition-colors" data-testid="nav-home">Home</Link>
          <Link to="/pricing" className="hover:text-emerald-400 transition-colors" data-testid="nav-pricing">Pricing</Link>
          {user && (
            <Link to="/dashboard" className="hover:text-emerald-400 transition-colors" data-testid="nav-dashboard">Dashboard</Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 border border-white/10 bg-white/[0.02] px-3 py-1.5 rounded-lg">
                <span className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Scans</span>
                <span className="font-mono font-semibold text-emerald-400" data-testid="header-scans-remaining">
                  {user.scans_remaining}
                </span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => { logout(); nav("/"); }}
                data-testid="logout-button"
                className="rounded-lg"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost" size="sm" className="rounded-lg text-sm" data-testid="header-signin">
                  Sign in
                </Button>
              </Link>
              <Link to="/register">
                <Button
                  size="sm"
                  className="rounded-lg bg-emerald-500 hover:bg-emerald-600 text-[#0a0f0d] font-semibold shadow-lg shadow-emerald-500/20"
                  data-testid="header-getstarted"
                >
                  Get Started
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
